import { AnyAction, Middleware, Store } from 'redux';
import { ThunkDispatch } from 'redux-thunk';

type _Store = Store<any, any> &
    Middleware<
        ThunkDispatch<{}, undefined, AnyAction>,
        {},
        ThunkDispatch<{}, undefined, AnyAction>
    >;

// eslint-disable-next-line import/no-mutable-exports
let store: _Store;
function setStore(settingStore: _Store) {
    store = settingStore;
}
function getStore() {
    return store;
}
export { store, setStore, getStore };
